import React from "react";
import logo from "../crescent.png"

const Navbar = () => {
    return(
        <div className="navbar bg-body-tertiary shadow">
            <div className="container">
                <a className="navbar-brand h1 mb-0" href="#">
                <img src={logo} alt="Logo" width="30" height="30" className="d-inline-block align-text-top" />
                <span className="mx-2 poppins-bold">IslamicGPT</span>
                </a>
                <div className="justify-content-center">
                <ul class="navbar-nav mx-2">
                    <li class="nav-item">
                    <h4 className="mb-0"><a class="nav-link active poppins-medium" aria-current="page" href="https://ko-fi.com/yahyazoom1727"><b><span><i class="fa-solid fa-heart-circle-plus"></i></span></b></a></h4>
                    </li>
                </ul>
                </div>
            </div>
        </div>
    );
};

export default Navbar;